export function isAlertVisible(crumb) {
  if (crumb) {
    return crumb.queryFactItem || (crumb.quickSearchItem && crumb.quickSearchItem.whereClauseImportToken);
  }
  return false;
}

export function buildAlertDeleteButtonId(id) {
  return `alert-delete-${id}`;
}
